import React from "react";
import "../../../../../Assets/Styles/Toast.scss";

const InfoToast = (props) => {
  return (
    <div className="info-toast">
      <p> {props.InfoMessage} </p>
      <button onClick={() => props.dismiss()}>
        {props.ButtonText ? props.ButtonText : "DISMISS"}
      </button>
    </div>
  );
};
export default InfoToast;
